export default __webpack_public_path__ + "static/media/story4.03972328.jpg";